import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import {
  toggleShowRent,
  toggleShowVerification,
  toggleShowConfirmation,
} from 'redux/Actions/ui-actions';

import styles from './rent.module.scss';
import ArrowLeft from '../../../../assets/arrow-left.svg';
import ArrowRight from '../../../../assets/arrow-right.svg';
import PhoneIcon from '../../../../assets/icon_phone.svg';
import EmailIcon from '../../../../assets/email-icon.svg';
import Button from '../../../Button/button';

const Rent = (props) => {
  const {
    showRentFUNC,
    showVerificationFUNC,
    showConfirmationFUNC,
    phoneNumber,
    arrivalDate,
    name,
    registrationNumbers,
    street,
    houseNumber,
    city,
    postCode,
    description,
  } = props;

  const { t } = useTranslation();

  const onSubmitReservation = () => {
    const url = 'https://api.bergregions.pl/api/dev/deposit/reservation/touch';

    axios
      .post(url, {
        phoneNumber,
        arrivalDate,
        name,
        registrationNumbers,
        street,
        houseNumber,
        city,
        postCode,
        description,
      })
      .then((response) => response.data())
      .catch(() => {
        // handle error
      });
  };

  const handleBackView = () => {
    showRentFUNC();
    showVerificationFUNC();
  };

  const handleNextStep = () => {
    onSubmitReservation();
    showRentFUNC();
    showConfirmationFUNC();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.rent}>
      <header>
        <h2 className={styles.rent__title}>{t('rentTitle')}</h2>
        <h2 className={styles.rent__title}>{t('rentTitle2')}</h2>
      </header>
      <p className={styles.rent__paragraph}>{t('rentParagraph')}</p>
      <div className={styles.rent__box}>
        <div
          className={styles.rent__boxPhoto}
          style={{
            background: `url('${process.env.PUBLIC_URL}/img/rent_person.jpg')`,
            backgroundSize: 'cover',
            backgroundPositionX: -10,
            backgroundPositionY: -15,
          }}
        />
        <div>
          <p>
            {t('rentContact')}
            <span className={styles.rent__paragraphBold}>{t('rentContactName')}</span>
          </p>
          <p className={styles.rent__contact}>
            <img className={styles.rent__phoneIcon} src={PhoneIcon} alt="Ikona telefonu" />
            {t('rentContactNumberPrefix')}
            <span className={styles.rent__contactBold}>&nbsp;{t('rentContactNumberFirst')}</span>
          </p>
          <p className={styles.rent__contact}>
            <img className={styles.rent__phoneIcon} src={PhoneIcon} alt="Ikona telefonu" />
            {t('rentContactNumberPrefix')}
            <span className={styles.rent__contactBold}>&nbsp;{t('rentContactNumberSecond')}</span>
          </p>
          <div className={styles.rent__contact}>
            <div className={styles.rent__email}>
              <img src={EmailIcon} alt="Ikona email" />
            </div>
            <span className={styles.rent__contactDecoration}>{t('rentContactEmail')}</span>
          </div>
        </div>
        <div
          className={styles.rent__boxQr}
          style={{
            background: `url('${process.env.PUBLIC_URL}/img/qr-code-berg.svg')`,
            backgroundSize: 'cover',
          }}
        />
      </div>

      <div className={styles.buttons}>
        <Button secondary onPress={handleBackView}>
          <img className={styles.buttons__arrowLeft} src={ArrowLeft} alt="Strzałka w lewo" />
          {t('formButtonBack')}
        </Button>
        <Button onPress={handleNextStep}>
          {t('formButtonForward')}
          <img className={styles.buttons__arrowRight} src={ArrowRight} alt="Strzałka w prawo" />
        </Button>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showVerificationFUNC: () => dispatch(toggleShowVerification()),
  showRentFUNC: () => dispatch(toggleShowRent()),
  showConfirmationFUNC: () => dispatch(toggleShowConfirmation()),
});

const mapStateToProps = (state) => ({
  phoneNumber: state.Form.phoneNumber,
  arrivalDate: state.Form.arrivalDate,
  name: state.Form.name,
  registrationNumbers: state.Form.registrationNumbers,
  street: state.Form.street,
  houseNumber: state.Form.houseNumber,
  city: state.Form.city,
  postCode: state.Form.postCode,
  description: state.Form.description,
});

export default connect(mapStateToProps, mapDispatchToProps)(Rent);
